import GSAP from "gsap";

export default class {
  constructor(container) {
    this.container = container || document.querySelector(".content");
    this.elements = {
      images: this.container.querySelectorAll(".single_project_image"),
      lightHouseContainer: this.container.querySelector(
        ".project__lighthouse__wrapper",
      ),
      lightHouseBackgroundImage: this.container.querySelector(
        ".background__image img",
      ),
      lightHouseForgroundImage: this.container.querySelector(
        ".image__wrapper img",
      ),
      nextBtn: this.container.querySelector(".right__btn"),
      prevBtn: this.container.querySelector(".left__btn"),
      centerNumber: this.container.querySelector(".slider__number p"),
      closeBtn: this.container.querySelector(".close__btn__wrapper button"),
      clickableImages: this.container.querySelectorAll(".clickable__image"),
      imageWrapper: this.container.querySelectorAll(".image__wrapper"),
      projectNameHeader: this.container.querySelector(".proejct__name__header"),
    };

    this.imagesArray = [];
    this.currentIndex = 0;
    this.totalSlides = this.imagesArray.length;

    // Track listeners for cleanup
    this._scrollHandler = null;
    this._clickHandlers = [];
    this._keydownHandler = null;
  }
  handleProjectNameHeader() {
    if (!this.elements.projectNameHeader) return;
    const header = this.elements.projectNameHeader;
    const startTop = 26;
    const endTop = -20;
    const startScroll = window.innerWidth > 1024 ? 1450 : 1200;
    const scrollRange = window.innerHeight;

    this._scrollHandler = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (scrollY < startScroll) {
        header.style.top = `${startTop}px`;
        return;
      }
      let progress = (scrollY - startScroll) / scrollRange;
      progress = Math.min(Math.max(progress, 0), 1);
      const newTop = startTop - progress * 20 * (startTop - endTop);
      header.style.top = `${newTop}px`;
    };

    window.addEventListener("scroll", this._scrollHandler, { passive: true });
    this._scrollHandler();
  }
  mobileDropDown() {
    if (!this.elements.images) return;

    this.elements.images.forEach((element) => {
      const btns = element.querySelectorAll(".dropdown_btn");
      const dropdowns = element.querySelectorAll(".caption__text");

      if (!btns.length || !dropdowns.length) return;

      btns.forEach((btn, index) => {
        // Pair each button with the dropdown at the same index
        const dropdown = dropdowns[index];
        if (!dropdown) return;

        const handler = () => {
          const isActive = btn.classList.contains("active");

          if (isActive) {
            // Close: collapse dropdown, remove active, rotate arrow to 180 (pointing down)
            dropdown.style.gridTemplateRows = "0fr";
            btn.classList.remove("active");
            GSAP.to(btn, {
              rotate: 180,
              duration: 0.6,
              ease: "power2.out",
            });
          } else {
            // Open: expand dropdown, add active, rotate arrow to 0 (pointing up)
            dropdown.style.gridTemplateRows = "1fr";
            btn.classList.add("active");
            GSAP.to(btn, {
              rotate: 0,
              duration: 0.6,
              ease: "power2.out",
            });
          }
        };

        btn.addEventListener("click", handler);
        this._clickHandlers.push({ element: btn, type: "click", handler });
      });
    });
  }
  lightHouseToggle() {
    if (
      !this.elements.clickableImages ||
      !this.elements.closeBtn ||
      !this.elements.nextBtn ||
      !this.elements.prevBtn ||
      !this.elements.lightHouseBackgroundImage ||
      !this.elements.lightHouseForgroundImage
    )
      return;
    this.elements.imageWrapper.forEach((elem) => {
      const btn = elem.querySelector(".open__lighthouse");
      if (btn) {
        const handler = () => {
          const image = elem.querySelector(".clickable__image");
          this.openLightHouse();
          this.currentIndex = this.imagesArray.indexOf(image);
          this.elements.lightHouseBackgroundImage.src = image.src;
          this.elements.lightHouseForgroundImage.src = image.src;
          this.elements.centerNumber.innerText = `0${this.currentIndex + 1}`;
        };
        btn.addEventListener("click", handler);
        this._clickHandlers.push({ element: btn, type: "click", handler });
      }
    });
    this.elements.clickableImages.forEach((image) => {
      if (image.src && image.src.trim() !== "") {
        this.imagesArray.push(image);
        this.totalSlides = this.imagesArray.length;
        const handler = () => {
          this.openLightHouse();
          this.currentIndex = this.imagesArray.indexOf(image);
          this.elements.lightHouseBackgroundImage.src = image.src;
          this.elements.lightHouseForgroundImage.src = image.src;
          this.elements.centerNumber.innerText = `0${this.currentIndex + 1}`;
        };
        image.addEventListener("click", handler);
        this._clickHandlers.push({ element: image, type: "click", handler });
      }
    });

    const closeHandler = () => this.closeLightHouse();
    this.elements.closeBtn.addEventListener("click", closeHandler);
    this._clickHandlers.push({
      element: this.elements.closeBtn,
      type: "click",
      handler: closeHandler,
    });

    const nextHandler = () => this.handleNext(this.currentIndex);
    this.elements.nextBtn.addEventListener("click", nextHandler);
    this._clickHandlers.push({
      element: this.elements.nextBtn,
      type: "click",
      handler: nextHandler,
    });

    const prevHandler = () => this.handlePrev(this.currentIndex);
    this.elements.prevBtn.addEventListener("click", prevHandler);
    this._clickHandlers.push({
      element: this.elements.prevBtn,
      type: "click",
      handler: prevHandler,
    });
  }

  openLightHouse() {
    GSAP.to(this.elements.lightHouseContainer, {
      opacity: 1,
      duration: 0.3,
      ease: "power2.out",
      onStart: () => {
        this.elements.lightHouseContainer.style.visibility = "visible";
      },
    });
  }
  closeLightHouse() {
    GSAP.to(this.elements.lightHouseContainer, {
      opacity: 0,
      duration: 0.3,
      onComplete: () => {
        this.elements.lightHouseContainer.style.visibility = "hidden";
      },
      ease: "power2.out",
    });
  }
  updateSlider(newIndex) {
    if (newIndex < 0) {
      newIndex = this.totalSlides - 1;
    } else if (newIndex >= this.totalSlides) {
      newIndex = 0;
    }
    const oldImage = this.elements.lightHouseForgroundImage;
    const oldImageBackground = this.elements.lightHouseBackgroundImage;
    const newImageSrc = this.imagesArray[newIndex].src;
    this.elements.lightHouseBackgroundImage.src = newImageSrc;
    this.elements.lightHouseForgroundImage.src = newImageSrc;
    this.currentIndex = newIndex;
    this.elements.centerNumber.innerText = `0${this.currentIndex + 1}`;
  }
  handleNext(index) {
    this.updateSlider(index + 1);
  }
  handlePrev(index) {
    this.updateSlider(index - 1);
  }
  bindKeyboardControls() {
    this._keydownHandler = (e) => {
      if (
        !this.elements.lightHouseContainer ||
        this.elements.lightHouseContainer.style.visibility === "hidden"
      ) {
        return;
      }

      switch (e.key) {
        case "Escape":
          e.preventDefault();
          this.closeLightHouse();
          break;
        case "ArrowLeft":
          e.preventDefault();
          this.handlePrev(this.currentIndex);
          break;
        case "ArrowRight":
          e.preventDefault();
          this.handleNext(this.currentIndex);
          break;
      }
    };

    document.addEventListener("keydown", this._keydownHandler);
  }

  unbindKeyboardControls() {
    if (this._keydownHandler) {
      document.removeEventListener("keydown", this._keydownHandler);
      this._keydownHandler = null;
    }
  }

  // DESTROY: Remove all event listeners
  destroy() {
    if (this._scrollHandler) {
      window.removeEventListener("scroll", this._scrollHandler);
      this._scrollHandler = null;
    }

    // Remove all click listeners
    this._clickHandlers.forEach(({ element, type, handler }) => {
      if (element) {
        element.removeEventListener(type, handler);
      }
    });
    this._clickHandlers = [];

    // Remove keyboard listener
    this.unbindKeyboardControls();
  }
}
